import { EntityId } from '@reduxjs/toolkit';
import { RootState } from '../../../_config/redux';
import { notificationEntityAdapter } from './notification.slice';

const notificationSelector = notificationEntityAdapter.getSelectors<RootState>((state) => state.notifications);

export const selectAllNotifications = (state: RootState) => state.notifications.notifications;

export const selectNotificationById = (id: EntityId) => (state: RootState) => notificationSelector.selectById(state, id);
